class Hash {
    constructor() {
        if (window.location.hash) {
            if (window.location.hash === "#zappa") {
                $('.js-zappa').addClass('show');

                $('.js-zappa-verder').on('click', () => {
                    $('.js-zappa').removeClass('show');
                    history.replaceState({}, document.title, ".");
                })
            }
        }
    }
}

module.exports = Hash;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/hash.js